
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clm/analytics",
      function () {
        return require("private-next-pages/clm/analytics/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clm/analytics"])
      });
    }
  